module.exports = __webpack_public_path__ + "img/qr_code.b2f22dd8.png";